/**
 * 封装 axios 请求模块
 */
import axios from 'axios'

// 创建一个axios实例对象
const request = axios.create({
  baseURL: 'https://smartold.ruizhihuitech.com/prod-api' //
  // baseURL: 'https://192.168.0.22:8082' //
  // baseURL: 'http://192.168.0.22:8082' //
})

// 配置请求拦截器

// 配置响应拦截器


// 暴露出去
export default request
